import { render, staticRenderFns } from "./table-active.vue?vue&type=template&id=a08e6800"
import script from "./table-active.vue?vue&type=script&lang=js"
export * from "./table-active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports